import React from "react";
export const FormCreatorSkeleton = () => {
  return (
    <div style={{ padding: "2rem" }}>
      {/* Stepper Skeleton */}
      {/* Form Section */}
      <div style={{ marginBottom: "2rem" }}>
        <div className="skeleton" style={{ width: "200px", height: "40px", marginBottom: "2rem" }}></div>

        {/* Two-column Form Row */}
        <div style={{ display: "flex", gap: "1rem", marginBottom: "1rem" }}>
          <div className="skeleton" style={{ width: "100%", height: "40px" }}></div>
          <div className="skeleton" style={{ width: "100%", height: "40px" }}></div>
        </div>

        <div style={{ display: "flex", gap: "1rem", marginBottom: "1rem" }}>
          <div className="skeleton" style={{ width: "100%", height: "40px" }}></div>
          <div className="skeleton" style={{ width: "100%", height: "40px" }}></div>
        </div>

        <div style={{ display: "flex", gap: "1rem", marginBottom: "1rem" }}>
          <div className="skeleton" style={{ width: "100%", height: "40px" }}></div>
          <div className="skeleton" style={{ width: "100%", height: "40px" }}></div>
        </div>
      </div>

      {/* Upload Document Section */}
      <div>
        <div className="skeleton" style={{ width: "150px", height: "20px", marginBottom: "0.5rem" }}></div>
        <div className="skeleton" style={{ width: "100%", height: "50px" }}></div>
      </div>
    </div>
  );
};
